import type { Dispatch, SetStateAction } from 'react'

import { useForm } from 'modules/core/hooks/useForm'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useCreateBreakConfiguration } from 'modules/time_categories_settings/hooks/breakConfigurations/useCreateBreakConfiguration'

export interface CustomBreakFormType {
  id?: number
  name: string
  paid: boolean
  breakTypeSelected: boolean
  archived: boolean
}

interface Props {
  setModalOpen: Dispatch<SetStateAction<boolean>>
  onSuccess?: (id: number | undefined) => void
}

const CreateCustomBreakForm = ({ setModalOpen, onSuccess }: Props) => {
  const { create } = useCreateBreakConfiguration()

  const defaultValues = {
    name: '',
    paid: false,
    breakTypeSelected: false,
    archived: false,
  }

  const form = useForm({
    defaultValues: defaultValues,
    onSubmit: async (data, { setErrors }) => {
      const payload = {
        ...data,
      }
      const result = await create(payload)
      const handled = handleResult(result, setErrors)
      if (handled.success) {
        setModalOpen(false)

        app.setFlash({
          type: 'correct',
          message: i18n.t('company_settings.time.breaks.create.success', {
            name: data.name,
          }),
        })
        form.resetForm()
        if (onSuccess) {
          onSuccess(handled.data?.breakConfiguration?.id)
        }
      } else {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('time_tracking.settings.time_blocks.categories.modals.name_error'),
        })
      }

      return handled
    },
  })

  return form
}

export default CreateCustomBreakForm
